exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".wV0GLq1bd2LIzJBOyd3tF{cursor:pointer}html[dir] .wV0GLq1bd2LIzJBOyd3tF{background:\"[theme:white, default:#ffffff]\";border-bottom:1px solid \"[theme:neutralLight, default:#eaeaea]\"}html[dir=ltr] .wV0GLq1bd2LIzJBOyd3tF{padding:12px 12px 0 26px}html[dir=rtl] .wV0GLq1bd2LIzJBOyd3tF{padding:12px 26px 0 12px}html[dir=ltr] ._3tisHvNCIu3fC-d2Q-nHEQ{margin-left:24px}html[dir=rtl] ._3tisHvNCIu3fC-d2Q-nHEQ{margin-right:24px}", ""]);
// Exports
exports.locals = {
	"infoBar": "wV0GLq1bd2LIzJBOyd3tF",
	"infoBarTextContainer": "_3tisHvNCIu3fC-d2Q-nHEQ"
};